import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import '../styles/header.scss'

import logo from '../../content/pages/home/logo.png'


export default function Header () {
  const data = useStaticQuery(graphql`
      query HeaderQuery {
          site {
              siteMetadata {
                  title
                  description
              }
          }
      }
  `)

  const { title, description } = data.site.siteMetadata

  return (
    <div className="site-header">
      <Link to={'/'} className="header-content">
        <div className="logo-wrap">
          <img className='logo' src={logo} alt="logo"/>
        </div>
        <div className="header-text">
          <h1>{title}</h1>
          <h4>{description}</h4>
        </div>
      </Link>
    </div>
  )
}
